import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <header className="bg-blue-800 text-white py-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-2">Privacy Policy</h1>
          <p className="text-lg">Effective Date: [Insert Date]</p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-10 text-gray-700 leading-relaxed">
        <section className="mb-8">
          <p>
            At <strong>Suitable Shelters</strong>, accessible from{" "}
            <a
              href="https://suitableshelters.com.ng"
              className="text-blue-600 underline"
            >
              https://suitableshelters.com.ng
            </a>, your privacy is our priority. This Privacy Policy describes how we collect, use, and protect your information.
          </p>
        </section>

        <hr className="my-6 border-gray-300" />

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">1. What We Collect</h2>
          <ul className="list-disc list-inside">
            <li><strong>Personal Info:</strong> Name, phone number, and email via forms.</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited (via server logs).</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">2. How We Use It</h2>
          <p>We use your information to:</p>
          <ul className="list-disc list-inside">
            <li>Respond to inquiries or service requests</li>
            <li>Provide updates about listed properties</li>
            <li>Enhance and improve user experience on our site</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">3. Data Sharing</h2>
          <p>
            We do <strong>not</strong> sell, trade, or share your personal information with third parties. Data is used only internally and securely stored.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">4. Security Measures</h2>
          <p>
            We follow best practices to keep your data safe and protect it from unauthorized access.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc list-inside">
            <li>Request access to your data</li>
            <li>Ask for correction or deletion</li>
            <li>Withdraw any previously given consent</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">6. Updates</h2>
          <p>
            This policy may change from time to time. The latest version will always be posted here.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-700 mb-2">7. Contact Us</h2>
          <p>
            For any questions or data requests, contact us at:{" "}
            <strong>{process.env.REACT_APP_CONTACT_US_EMAIL}</strong>
          </p>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
